import Scroll from 'react-scroll';

export const scrollContainerId = 'scroll-container';

export function scrollToWithinContainer(containerId: string, containerName: string): void {
    Scroll.scroller.scrollTo(containerName, getScrollOptions(containerId));
}

export function scrollToTopWithinContainer(containerId: string): void {
    Scroll.animateScroll.scrollToTop(getScrollOptions(containerId));
}

export function scrollToBottomWithinContainer(containerId: string): void {
    Scroll.animateScroll.scrollToBottom(getScrollOptions(containerId));
}

export function scrollToContainerItemOrTop(item?: string | null): void {
    if (item) {
        scrollToWithinContainer(scrollContainerId, item);
    } else {
        scrollToTopWithinContainer(scrollContainerId);
    }
}

export function calculateOffset(): number | undefined {
    const navigationBarHeight = 64;
    const episodeHeader = document.getElementById('episode-header');
    if (episodeHeader) {
        return -(episodeHeader.offsetHeight + navigationBarHeight + 12);
    }
}

function getScrollOptions(containerId: string) {
    return {
        containerId,
        delay: 0,
        duration: 800,
        offset: calculateOffset(),
        smooth: 'easeInOutQuart',
    };
}
